import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { Observable, Subscription } from "rxjs";
import { SameWordValidator } from "src/app/directives/same-word.directive";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { FormrulesConfigService } from "src/app/shared/configuration/formrules-config.service";
import { AuthenticatedResponse } from "src/app/shared/models/AuthenticatedResponse";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { AuthConfigService } from "../_services/auth-config.service";
import { AuthService } from "../_services/auth.service";

enum ErrorStates {
   NotSubmitted,
   HasError,
   NoError,
}

@Component({
   selector: "app-change-password",
   templateUrl: "./change-password.component.html",
   styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
   @ViewChild("currentSwal") private currentSwal: SwalComponent;
   @ViewChild("errorSwal") private errorSwal: SwalComponent;
   changePasswordForm: FormGroup;
   userData: any;
   isLoading$: Observable<boolean>;
   private unsubscribe: Subscription[] = [];
   errorState: ErrorStates = ErrorStates.NotSubmitted;
   errorStates = ErrorStates;
   public loading: boolean = false;
   constructor(private formBuilder: FormBuilder, private authService: AuthService, private config: TokenStorageService, private formConfig: FormrulesConfigService, private router: Router, private tokenService: TokenStorageService, private utilities: UtilitiesService) {
      this.isLoading$ = this.authService.isLoading$;
   }

   ngOnInit(): void {
      this.initChangePassForm();
   }

   initChangePassForm() {
      this.changePasswordForm = this.formBuilder.group(
         {
            tempPassword: ["", Validators.compose([Validators.required, Validators.minLength(this.formConfig.passwordMinLength), Validators.maxLength(this.formConfig.passwordMaxLength)])],
            password: ["", Validators.compose([Validators.required, Validators.minLength(this.formConfig.passwordMinLength), Validators.maxLength(this.formConfig.passwordMaxLength)])],
            repeatPassword: ["", Validators.compose([Validators.required, Validators.minLength(this.formConfig.passwordMinLength), Validators.maxLength(this.formConfig.passwordMaxLength)])],
         },
         {
            validators: SameWordValidator,
         }
      );
   }

   get f() {
      return this.changePasswordForm.controls;
   }

   changePassword() {
      if (this.changePasswordForm.valid === true) {
         let password;
         let tempPassword;
         let currentUser;
         try {
            password = this.f.password.value;
            tempPassword = this.f.tempPassword.value;
            currentUser = this.tokenService.getUser() as SessionUser;
            this.loading = true;
            const authSubscription = this.authService.changeTempPassword(currentUser.id, password, tempPassword).subscribe(
               (result) => {
                  this.loading = false;
                  this.currentSwal.icon = "success";
                  this.currentSwal.title = "Cambio de Contraseña";
                  this.currentSwal.text = result.message;
                  this.currentSwal.fire();
               },
               (error) => {
                  this.loading = false;
                  this.errorSwal.title = "Error en cambio de contraseña";
                  this.errorSwal.text = "No ha sido posible cambiar su contraseña, intente solicitar una nueva contraseña temporal." + this.utilities.setErrorMessageFromArray(error.error);
                  this.errorSwal.fire();
               }
            );
            this.unsubscribe.push(authSubscription);
         } catch (error) {
            this.loading = false;
         }
      }
   }

   returnToLogin() {
      this.tokenService.signOut();
      this.router.navigate([""]);
   }

   ngOnDestroy() {
      this.unsubscribe.forEach((sb) => sb.unsubscribe());
   }

   loadUserData() {
      let userDataInput = this.config.getUser();
      return (this.userData = userDataInput);
   }
}
